import React from "react";
import { AppProvider, Link as PolarisLink } from "@shopify/polaris";
import { Link as ReactRouterLink, useNavigate } from "react-router-dom";
import enTranslations from "@shopify/polaris/locales/en.json";

export default function PolarisProvider({ children }) {
  const theme = {
    colors: {
      // primary: "#ff616e",
    },
  };

  return (
    <AppProvider
      i18n={enTranslations}
      theme={theme}
      linkComponent={(params) => Link(params)}
    >
      {children}
    </AppProvider>
  );
}

const IS_EXTERNAL_LINK_REGEX = /^(?:[a-z][a-z\d+.-]*:|\/\/)/;
function Link({ children, url = "", external, ref, useRRLink, ...rest }) {
  if (external && IS_EXTERNAL_LINK_REGEX.test(url)) {
    rest.target = "_blank";
    rest.rel = "noopener noreferrer";
    return (
      <a href={url} {...rest}>
        {children}
      </a>
    );
  }

  // Use React Router Link for internal navigation
  return (
    <ReactRouterLink to={url} {...rest}>
      {children}
    </ReactRouterLink>
  );
}
